<template>
	<div id="systemrole">
		<HrrBreadcrumb PMname="用户权限管理" CMname="角色模块功能管理" />
		<HrrDetailLayout>
			<template slot="head" >
				角色：{{title}}
			</template>
			<template slot="Form" >
				<el-row :gutter="24">
					<el-col :span="10" >
						<el-input placeholder="输入关键字查找模块功能" v-model="filterText" ></el-input>
					</el-col>
					<el-col :span="14" >
						<el-button type="primary" @click="Treeexpand(true)" >全部展开</el-button>
						<el-button type="info" @click="Treeexpand(false)" >全部收起</el-button>
					</el-col>
				</el-row>
				<br />
				<el-row :gutter="24">
					<el-col :span="10" >
						<el-tree
						show-checkbox
						:data="treeData"
						:props="defaultProps"
						node-key="moduleId"
						highlight-current
						:filter-node-method="filterNode"
						:default-expand-all="defaultexpandall"
						ref="FunTree"
						v-loading="loading">
						</el-tree>
					</el-col>
					<el-col :span="14" >
						
					</el-col>
				</el-row>
		</template>
		<template slot="buttons" >
			<el-button type="primary" @click="submitMForm" >提 交</el-button>
			<el-button  @click="clearMForm" >清 空</el-button>
			<el-button type="info" @click="returnMForm()" >返 回</el-button>
		</template>
	</HrrDetailLayout>
</div>
</template>
<script>
	export default {
		name: 'role_fun',
		watch:{
			filterText(val) {
				this.filterArr.length=0;
				this.$refs.FunTree.filter(val);
			}
		},
		data(){
			return{
				defaultexpandall:false,
				filterText:"",
				filterArr:[],
				treeData:[],
				mytreeData:[],
				defaultProps: {
					children: 'childList',
					label: 'moduleName'
				},
				title:"",
				loading:true
			}
		},
		methods:{
			Treeexpand(val){
				for(var i=0;i<this.$refs.FunTree.store._getAllNodes().length;i++){
		           this.$refs.FunTree.store._getAllNodes()[i].expanded=val;
		        }
			},
			filterNode(value, data) {
				if (!value){
					return true;
				}
				if(data.moduleName.indexOf(value)!==-1){
					this.filterArr.push(data.moduleId.toString());
					return true;
				}
				if(data.moduleId.toString().indexOf('-')!==-1){
					var m_id=data.moduleId.split("-")[0];
					return this.filterArr.indexOf(m_id)!==-1;
				}
				return false;
			},
			submitMForm:function(){
				var selectnodes=this.$refs.FunTree.getCheckedNodes(true);
				if(selectnodes.length<1){
					this.$message({message:"请先选择功能在操作",type:"warning"});
					return;
				}
	    		var loading = this.$loading({
	    			lock: true,
	    			text: '提交中...',
	    			spinner: 'el-icon-loading',
	    			background: 'rgba(0, 0, 0, 0.7)'
	    		});
	    		var Vuethis=this;
	    		var form={roleId:parseInt(this.$route.params.id)};
	    		form.roleModuleFunReList=[];
	    		selectnodes.forEach( function(element, index) {
	    			var moduleId=parseInt(element.moduleId.split('-')[0]);
	    			var functionId=parseInt(element.functionId);
	    			form.roleModuleFunReList.push({moduleId:moduleId,functionId:functionId})
	    		});
	    		this.$hrraxios.post(this.$api.system.roleFunctions,form)
	    		.then(function(response){
	    			loading.close();
	    			var data=response.data;
	    			if(data.Success==true)
	    			{
	    				Vuethis.$alert("提交成功！",{callback:action=>{
							Vuethis.$router.push({path:'/system/role'});
						}});
					}else {
						Vuethis.$message.error(data.Prompt);
					}
				}).catch(function(error){
					loading.close();
					console.log(error);
				})
            },
            clearMForm:function() {
            	this.$refs.FunTree.setCheckedKeys([]);
            },
            returnMForm:function(){
            	this.$router.go(-1);
            },
            initData:function(){
            	var row=this.$route.meta.row;
            	this.title=row.roleName;
            	this.loading=true;
            	var Vuethis=this;
            	this.$hrraxios.get(this.$api.system.moduleTree)
            	.then((response)=>{
            		Vuethis.loading=false;
            		var data=response.data;
            		if(data.Success==true)
            		{
            			Vuethis.treeData=data.Data;
            			Vuethis.initSelectedData();
            		}else{
            			Vuethis.$message.error(data.Prompt);
            		}
            	})
            	.catch((error)=>{
            		Vuethis.loading=false;
            	})
            },
            initSelectedData(){
            	var roleId=this.$route.params.id;
            	var Vuethis=this;
            	this.$hrraxios.get(this.$api.system.roleFunctions+"/"+roleId)
            	.then((response)=>{
            		var redata=response.data;
            		if(redata.Success==true){
            			Vuethis.mytreeData=redata.Data;
            			Vuethis.$refs.FunTree.setCheckedNodes(Vuethis.mytreeData);
            		}else{
            			Vuethis.$message.error(redata.Prompt);
            		}
            	})
            	.catch((error)=>{
            		console.log(error);
            	})

            }

        },
        created:function(){
        	this.initData();
        }
    }
</script>
<style>
.el-form-module{width:500px;}
</style>
